/* @ngInject */
const invoiceExcel = (
  valueHandler,
  excelUtils,
  fixedPartOptions,
  optionsHandler,
  matcher,
  $filter,
  linearOptions,
  perDayLimitedOptions,
  perDayOptions,
  utils,
) => {
  const self = {}

  const defaultOptions = {}

  self.checkOptions = (options) => {
    if (!valueHandler.isObject(options)) {
      throw Error('Options not valid')
    }
    if (!valueHandler.isObject(options.invoice)) {
      throw Error('Invoice options not valid')
    }
    if (!valueHandler.isObject(options.invoice.owner)) {
      throw Error('Owner options not valid')
    }
  }

  self.generate = (name, options) => {
    options = self.getOptions(name, options)

    return excelUtils.getWorkbook(options.filename)
      .then((workbook) => {
        options.wagons = $filter('orderBy')(options.wagons, options.sortOrder)

        const sheet1 = workbook.sheet(0)
        sheet1.active(true)
        self.setDetail(sheet1, options)

        const sheet2 = workbook.sheet(1)
        self.setResume(sheet2, options)

        const sheet3 = workbook.sheet(2)
        self.setInvoice(sheet3, options)

        return workbook.outputAsync({
          type: '',
        })
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.download = (name, options) => {
    const defaultOptions = {
      invoice: {},
      wagons: [],
      title: 'Facturation',
      firstRow: 7,
      rowHeight: 15,
      sortOrder: ['arrivalDate',],
    }

    options = optionsHandler.setDefaults(options, defaultOptions)
    self.checkOptions(options)

    return self.generate(name, options)
      .then((blob) => {
        excelUtils.downloadWorkbook(blob, options.title)
      })
      .catch((err) => {
        console.error(err.message || err)
        throw err
      })
  }

  self.getOptions = (name, options = {}) => {
    if (matcher.contain(name, 'fixed|Fixed|fix|Fix')) {
      return fixedPartOptions.generateOptions(options)
    } else if (matcher.contain(name, 'linear|Linear')) {
      return linearOptions.generateOptions(options)
    } else if (matcher.contain(name, 'limited|Limited')) {
      return perDayLimitedOptions.generateOptions(options)
    } else if (matcher.contain(name, 'day|Day|daily|Daily')) {
      return perDayOptions.generateOptions(options)
    } else {
      return defaultOptions
    }
  }

  self.setDetail = (sheet, options) => {
    self.setHeader(sheet, options)
    self.setBody(sheet, options)
    self.setFooter(sheet, options)
  }

  self.setHeader = (sheet, options) => {
    options.getHeaderData(options).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.setBody = (sheet, options) => {
    const wagons = options.wagons
    for (let wagonIndex = 0; wagonIndex < wagons.length; wagonIndex++) {
      const wagon = wagons[wagonIndex]
      options.currentRow = options.firstRow + wagonIndex
      self.setRow(sheet, wagon, options)
    }
  }

  self.setRow = (sheet, wagon, options) => {
    wagon.dispositionDates = ''
    const dateBegin = utils.date.stringToTimestamp(options.invoice.dateBegin)
    const dateEnd = utils.date.stringToTimestamp(options.invoice.dateEnd)

    let nbArg = 0

    if (wagon.dispositions.length > 0) {
      wagon.dispositions.forEach(disposition => {
        if (disposition.date >= dateBegin && disposition.date <= dateEnd) {
          const date = utils.date.timestampToString(disposition.date)
          if (nbArg === 0) {
            wagon.dispositionDates += '=CONCATENATE("' + date + '"'
          } else {
            wagon.dispositionDates += ', CHAR(10), "' + date + '"'
          }
          nbArg++
        }
      })
      if (nbArg) {
        wagon.dispositionDates += ')'
        sheet.row(options.currentRow).height(options.rowHeight * nbArg)
      }
    }

    options.getBodyData(wagon, options).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.setFooter = (sheet, options) => {
    options.getFooterData(options).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }

  self.setResume = (sheet, options) => {
    options.getResumeHeaderData(options).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })

    for (let index = 0; index < options.wagons.length; index++) {
      options.currentRow = index
      options.getResumeData(options).forEach(cellInfo => {
        excelUtils.setCell(sheet, cellInfo)
      })
    }
  }

  self.setInvoice = (sheet, options) => {
    options.getInvoiceData(options).forEach(cellInfo => {
      excelUtils.setCell(sheet, cellInfo)
    })
  }


  return self
}
export default invoiceExcel



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/invoice/invoiceExcel.service.js